import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';

/*
  Generated class for the CommonDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CommonDataProvider {


  constructor() {
    console.log('Hello CommonDataProvider Provider');
  }

  // databaseProvider.fetchFromCustomers();
  public countryCode: string = '';


}



// WEBPACK FOOTER //
// ./src/providers/common-data/common-data.ts